import { ReactNode } from 'react';

import { Navigate, useSearchParams } from 'react-router-dom';

import { useAuth } from '@/contexts/auth';

import LoadingFull from '@/components/LoadingFull';

interface AuthRouteProps {
  children: ReactNode;
}

const getSafeRedirectPath = (redirect: string | null): string => {
  if (!redirect) return '/app/reports';
  if (!redirect.startsWith('/') || redirect.startsWith('//')) {
    return '/app/reports';
  }
  return redirect;
};

export const AuthRoute = ({ children }: AuthRouteProps) => {
  const { isAuthenticated, isLoading } = useAuth();
  const [searchParams] = useSearchParams();

  if (isLoading) {
    return <LoadingFull />;
  }

  if (isAuthenticated) {
    const redirect = getSafeRedirectPath(searchParams.get('redirect'));
    return <Navigate to={redirect} replace />;
  }

  return <>{children}</>;
};
